<template>
  <v-breadcrumbs :items="crumbs">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :to="{path: item.href}"
        exact
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs> 
</template>
<script>
  export default {
    props: {
      crumbs: { 
        type: Array,
        default: function () {
          return [{ 
            text: 'Trang chủ',
            href: '/' 
          }]
        }
      }
    }
  }
</script>